<template>
  <v-container fluid grid-list-xl pt-0>
    <v-toolbar flat height="50" class="v-toolbar-header">
      <v-toolbar-title>
        <v-flex pl-4 class="d-flex align-center">
          <v-combobox
            class="width-300 text-xs-left"
            name="commissionType"
            v-validate="'required'"
            :error-messages="errors.collect('select.commissionType')"
            v-model="commissionType"
            :items="items"
            flat
            item-text="title"
            :allow-overflow="false"
            type="button"
            single-line
            return-object
          >
            <template slot="selection" slot-scope="data">
              <div>
                <span style="color:#005cae">{{data.item.title}}</span>
              </div>
            </template>
          </v-combobox>

          <!-- 124840 Tutorial ingreso automático de facturas -->
          <a href="#" @click.prevent="showManualModal = true" style="color: #005cae; text-decoration: none; margin-left: 4rem; font-size: 14px;">
            <v-icon small class="fas fa-hand-point-right mr-1 mb-1"></v-icon>
            Tutorial para ingreso automático de facturas
          </a>
        </v-flex>
        
        <v-dialog v-model="showManualModal" max-width="600px">
          <v-card>
            <v-toolbar color="primary" dark flat>
              <v-toolbar-title>Ingreso automático de Facturas</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon @click="showManualModal = false">
                <v-icon>close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text style="height: 380px;">
              <iframe width="560" height="315" src="https://www.youtube.com/embed/ARThFuES_Bc?si=Nf9whtGMulcWZ160" title="Ingreso automático de facturas" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items style="margin-right: 2.5% !important;" v-if="commissionType">
        <v-btn
          class="hidden-xs-only"
          style="height:50%;margin-left: 5% !important;"
          small
          v-if="commissionType.id==1 && showButtonGenerate"
          @click="sendCommissionsPreliquidationGeneration"
          color="accent"
          :disabled="botonGenerar"
        >Generar</v-btn>
        <v-btn
          class="hidden-xs-only"
          style="height:50%;margin-left: 5% !important;"
          small
          v-if="commissionType.id==1"
          @click="generateMassive"
          color="accent"
          :disabled="botonGenerar"
        >Reporte Masivo</v-btn>
        <v-btn
          class="hidden-xs-only"
          style="height:50%;margin-right: 3% !important;"
          small
          :disabled="botonAprobarAprove"
          v-if="commissionType.id==2  && !permissionApproveAndBill && $refs.preAproveList!=null"
          @click="sendCommissionsPreliquidationApprove"
          color="accent"
        >Aprobar</v-btn>
        <v-btn
          class="hidden-xs-only"
          style="height:50%;margin-right: 3% !important;"
          small
          :disabled="botonAprobarAprove"
          v-if="commissionType.id==2  && permissionApproveAndBill && $refs.preAproveList!=null"
          @click="sendCommissionsPreliquidationApprove"
          v-model="botonAprobarAprove"
          color="accent"
        >Aprobar</v-btn>
        <!--   <v-btn
          class="hidden-xs-only"
          style="height:50%;margin-right: 3% !important;"
          small
          :disabled="$refs.preAproveList.selectedValue!=null?false:true"
          v-if="commissionType.id==2 && permissionApproveAndBill&&$refs.preAproveList!=null"
          @click="sendCommissionsPreliquidationApproveAndBill"
          color="accent">
          Aprobar y facturar
        </v-btn>-->
        <v-btn
          class="hidden-xs-only"
          style="height:50%;margin-right: -1.6% !important;"
          small
          :disabled="$refs.preAproveList.selectedValue!=null?false:true"
          v-if="commissionType.id==2&&$refs.preAproveList!=null"
          @click="sendCommissionsPreliquidationReject"
          color="accent"
        >Rechazar</v-btn>
        <v-menu style="margin-left: 4% !important;" bottom left>
          <v-btn slot="activator" icon>
            <v-icon>more_vert</v-icon>
          </v-btn>
          <v-list>
            <v-list-tile
              class="hidden-xs-only"
              :disabled="$refs.preAproveList.selectedValue!=null?false:true"
              v-if="commissionType.id==2 && permissionApproveAndBill&&$refs.preAproveList!=null"
              @click="sendCommissionsPreliquidationApproveAndBill"
            >
              <v-list-tile-title>Aprobar y facturar</v-list-tile-title>
            </v-list-tile>
            <v-list-tile class="hidden-sm-and-up" v-if="commissionType.id==1">
              <v-list-tile-title @click="sendCommissionsPreliquidationGeneration">Generar</v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="generateExcel">
              <v-list-tile-title>Generar archivo excel</v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="generatePDF">
              <v-list-tile-title>Generar archivo pdf</v-list-tile-title>
            </v-list-tile>
            <v-list-tile
              class="hidden-sm-and-up"
              :disabled="$refs.preAproveList.selectedValue!=null?false:true"
              v-if="commissionType.id==2  && !permissionApproveAndBill &&$refs.preAproveList!=null"
            >
              <v-list-tile-title @click="sendCommissionsPreliquidationApprove">Aprobar</v-list-tile-title>
            </v-list-tile>
            <v-list-tile
              class="hidden-sm-and-up"
              :disabled="$refs.preAproveList.selectedValue!=null?false:true"
              v-if="commissionType.id==2  && permissionApproveAndBill && $refs.preAproveList!=null"
              @click="sendCommissionsPreliquidationApprove"
            >
              <v-list-tile-title>Aprobar</v-list-tile-title>
            </v-list-tile>

            <v-list-tile
              class="hidden-sm-and-up"
              :disabled="$refs.preAproveList.selectedValue!=null?false:true"
              v-if="commissionType.id==2 && permissionApproveAndBill&&$refs.preAproveList!=null"
              @click="sendCommissionsPreliquidationApproveAndBill"
            >
              <v-list-tile-title>Aprobar y facturar</v-list-tile-title>
            </v-list-tile>
            <v-list-tile
              :disabled="$refs.preAproveList.selectedValue!=null?false:true"
              v-if="commissionType.id==2&&$refs.preAproveList!=null"
              class="hidden-sm-and-up"
              @click="sendCommissionsPreliquidationReject"
            >
              <v-list-tile-title>Rechazar</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </v-toolbar-items>
    </v-toolbar>
    <preliquidation v-if="commissionType && commissionType.id==1"></preliquidation>
    <preliquidation-approval ref="preAproveList" v-if="commissionType && commissionType.id==2"></preliquidation-approval>
    <liquidation-query ref="liqQuery" v-if="commissionType && commissionType.id==3"></liquidation-query>
    <liquidation-comission v-if="commissionType && commissionType.id==4"></liquidation-comission>
    <preliquidation-query ref="preliquidationsQuery" v-if="commissionType && commissionType.id==5"></preliquidation-query>
    <square-comission ref="squareComission" v-if="commissionType && commissionType.id==6"></square-comission>

  </v-container>
</template>
<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import { nzDate } from "@/common/helpers/helpers";
import { downloadPDF } from "@/common/helpers/helpers";
import { downloadEXCEL } from "@/common/helpers/helpers";
import { i18n } from "@/main";
import router from "@/router";
import AppConfig from '@/config/AppConfig'

import Preliquidation from "./Preliquidation.vue";
import PreliquidationApproval from "./PreliquidationApproval.vue";
import LiquidationQuery from "./LiquidationQuery.vue";
import PreliquidationQuery from "./PreliquidationQuery";
import LiquidationComission from "./LiquidationComission";
import SquareComission from "./SquareComission";
export default {
  components: {
    Preliquidation,
    PreliquidationApproval,
    LiquidationQuery,
    PreliquidationQuery,
    LiquidationComission,
    SquareComission
  },
  computed: {
    ...mapGetters([
      "commissionsSelected",
      "permissionApproveAndBill",
      "commissionsVisualizePdf",
      "commissionsPdf",
      "commissionsExcel",
      "squareCommissionsPdf",
      "squareCommissionsExcel",
      "commissionsVisualizeExcel",
      "agency",
      "broker",
      "userId",
      "apsId",
      "isBroker",
      "preliquidationsExcel"
    ])
  },
  async mounted() {
    this.$store.dispatch("getBroker");
    this.$store.dispatch("getUserId");
    this.$store.dispatch("getApsId");
    this.commissionType = this.items[0];
    if(this.broker == "CIFRASEG S.A."){
      let it = {
        id: 5,
        title: i18n.t("message.preliquidationQuery")
      };
      this.items.push(it);
    }
    
    if(this.userId === AppConfig.BrokerKerygmaseg || (this.apsId != undefined  && this.apsId === AppConfig.BrokerKerygmaseg)){
      this.items.push({
        id: 6,
        title: i18n.t("message.squareComission")
      });
    }
    this.$store.dispatch("validatePermission");
    
    await this.$store.dispatch("validateIsUserAgent", this.userId);
    this.showButtonGenerate = this.isBroker;
    console.log(this.isBroker);
    
  },
  watch: {
    agency(val) {
      this.$store.dispatch("validatePermission");
      this.$store.dispatch("updateCommissionSelected", null);

    }
  },
  methods: {
    async IsUserAgent(){
      var isInactive = false;
     await this.$store
        .dispatch("validateIsUserAgent", this.userId)
        .then(result => {
          // if(this.brokerProfile.EstadoBroker == "I"){
          //   isInactive = true;
          // }
          this.showButtonGenerate = false;
        });
    
      return isInactive;


    },
    async sendCommissionsPreliquidationGeneration() {
      this.botonGenerar = true;
     await this.$store
        .dispatch("sendCommissionsPreliquidationGeneration")
        .then(res => {
          this.$store.dispatch("getCommissionsVisualize");
        }).catch((error)=>{
          this.$store.dispatch("getCommissionsVisualize");
          this.$root.$emit(
          "showSnackBar",
          "Existe un error al generar "+ error,
          "warning"
        );
        });
        this.botonGenerar = false;
    },
    async  sendCommissionsPreliquidationApprove() {
        this.botonAprobarAprove = true;
        this.botonAprobarAproveBill = true;
       if (this.$refs.preAproveList.selectedValue != null) {
        await this.$store
          .dispatch(
            "sendCommissionsPreliquidationApprove",
            this.$refs.preAproveList.selectedValue
          )
          .then(res => {
            this.botonAprobarAprove = false;
            this.botonAprobarAproveBill = false;
          }).catch((error)=>{
            this.botonAprobarAprove = false;
            this.botonAprobarAproveBill = false;

            this.$root.$emit(
          "showSnackBar",
          "Existe un error al aprobar "+ error,
          "warning"
        );
          });
      } else {
        this.$root.$emit(
          "showSnackBar",
          "Debe seleccionar al menos una preliquidación",
          "warning"
        );
      }
      this.$refs.preAproveList.selectedValue!=null?false:true
      this.$refs.preAproveList.refresh();
    },
    sendCommissionsPreliquidationApproveAndBill() {
      
        this.botonAprobarAproveBill = true;
        this.botonAprobarAprove = true;
      if (this.$refs.preAproveList.selectedValue != null) {
        this.$store
          .dispatch(
            "sendCommissionsPreliquidationApproveAndBill",
            this.$refs.preAproveList.selectedValue
          )
          .then(res => {
            this.botonAprobarAproveBill = false;
            this.botonAprobarAprove = false;
            }).catch((error)=>{
              this.botonAprobarAproveBill = false;
            this.botonAprobarAprove = false;
              this.$root.$emit(
          "showSnackBar",
          "Existe un error al aprobar "+ error,
          "warning");
            });
      } else {
        this.$root.$emit(
          "showSnackBar",
          "Debe seleccionar al menos una preliquidación",
          "warning"
        );
      }
      this.$refs.preAproveList.selectedValue!=null?false:true
      this.$refs.preAproveList.refresh();
    },
    sendCommissionsPreliquidationReject() {
      if (this.$refs.preAproveList.selectedValue != null) {
        this.$store
          .dispatch(
            "sendCommissionsPreliquidationReject",
            this.$refs.preAproveList.selectedValue
          )
          .then(res => {
            if (res) {
              this.$refs.preAproveList.refresh();
            }
          });
      } else {
        this.$root.$emit(
          "showSnackBar",
          "Debe seleccionar al menos una preliquidación",
          "warning"
        );
      }
    },
    generateMassive(){
      this.$store
        .dispatch(
          "getCommissionsMassive"
        )
        .then(res => {
          if (res) {
            this.$root.$emit(
              "showSnackBar",
              "Se enviará a su correo el reporte",
              "success"
            );
          }
        });
    },
    generatePDF() {
      switch (this.commissionType.id) {
        case 1:
          this.$store.dispatch("getCommissionsVisualizePDF").then(res => {
            if (res != null) {
              if (this.commissionsVisualizePdf.byteLength < 100) {
                this.$root.$emit("showSnackBar", "No existen datos", "warning");
                return;
              }
              downloadPDF(this.commissionsVisualizePdf, 
                "COMISIONES_"
                  .concat(new Date().getFullYear())
                  .concat(("0" + (new Date().getMonth() + 1)).slice(-2))
                  .concat((("0" + (new Date().getDate())).slice(-2)))
                  .concat((("0" + (new Date().getHours() + 1)).slice(-2)))
                  .concat((("0" + (new Date().getMinutes() + 1)).slice(-2)))
                  .concat((("0" + (new Date().getSeconds() + 1)).slice(-2)))
                  .concat((("0" + (new Date().getMilliseconds() + 1)).slice(-2)))
                  .concat(".pdf")
                );
            }
          });
          break;
        case 2:
          if (this.$refs.preAproveList.selectedValue != null) {
            if (this.$refs.preAproveList.selected[0].massive === "SI"){
              this.$store
              .dispatch(
                "generatePreliquidationMassive", this.$refs.preAproveList.selectedValue
              )
              .then(res => {
                if (res) {
                  this.$root.$emit(
                    "showSnackBar",
                    "Se enviará a su correo el reporte",
                    "success"
                  );
                }
              });
            }
            else{
              this.$store
              .dispatch(
                "getCommissionsPDF",
                this.$refs.preAproveList.selectedValue
              )
              .then(res => {
                if (this.commissionsPdf.byteLength < 100) {
                  this.$root.$emit(
                    "showSnackBar",
                    "No existen datos",
                    "warning"
                  );
                  return;
                }
                downloadPDF(this.commissionsPdf, "PRELIQUIDACION_".concat(this.$refs.preAproveList.selectedValue).concat(".pdf"));
              });
            }
          } else {
            this.$root.$emit(
              "showSnackBar",
              "Debe seleccionar al menos una preliquidación",
              "warning"
            );
          }
          break;
        case 3:
          if (this.$refs.liqQuery.selectedValue != null) {
            if (this.$refs.liqQuery.commissionsLiquidation.find(({ number }) => number ===  this.$refs.liqQuery.selectedValue)["massive"] === "SI"){
              this.$store
              .dispatch(
                "generateLiquidationMassive", this.$refs.liqQuery.selectedValue
              )
              .then(res => {
                if (res) {
                  this.$root.$emit(
                    "showSnackBar",
                    "Se enviará a su correo el reporte",
                    "success"
                  );
                }
              });
            }
            else{
            this.$store
              .dispatch("getCommissionsPDF", this.$refs.liqQuery.selectedValue)
              .then(res => {
                if (this.commissionsPdf.byteLength < 100) {
                  this.$root.$emit(
                    "showSnackBar",
                    "No existen datos",
                    "warning"
                  );
                  return;
                }
                downloadPDF(this.commissionsPdf, "LIQUIDACION_".concat(this.$refs.liqQuery.selectedValue).concat(".pdf"));
              });
            }
          } else {
            this.$root.$emit(
              "showSnackBar",
              "Debe seleccionar al menos una preliquidación",
              "warning"
            );
          }
          break;
          case 6:
          this.$store
            .dispatch("getSquareCommissionsPDF", this.$refs.squareComission.filters)
            .then(res => {
              if (this.squareCommissionsPdf.byteLength < 100) {
                this.$root.$emit(
                  "showSnackBar",
                  "No existen datos",
                  "warning"
                );
                return;
              }
              downloadPDF(this.squareCommissionsPdf, "CuadreComisiones.pdf");
            });
          
          break;
        default:
          this.$root.$emit("showSnackBar", "No implementado", "warning");
          break;
      }
    },
    generateExcel() {
      switch (this.commissionType.id) {
        case 1:
          this.$store.dispatch("getCommissionsVisualizeExcel").then(res => {
            if (this.commissionsVisualizeExcel.byteLength < 100) {
              this.$root.$emit("showSnackBar", "No existen datos", "warning");
              return;
            }
            downloadEXCEL(
              this.commissionsVisualizeExcel,
              "COMISIONES_"
                .concat(new Date().getFullYear())
                .concat(("0" + (new Date().getMonth() + 1)).slice(-2))
                .concat((("0" + (new Date().getDate())).slice(-2)))
                .concat((("0" + (new Date().getHours() + 1)).slice(-2)))
                .concat((("0" + (new Date().getMinutes() + 1)).slice(-2)))
                .concat((("0" + (new Date().getSeconds() + 1)).slice(-2)))
                .concat((("0" + (new Date().getMilliseconds() + 1)).slice(-2)))
                .concat(".xlsx")
            );
          });
          break;
        case 2:
          if (this.$refs.preAproveList.selectedValue != null) {
            if (this.$refs.preAproveList.selected[0].massive === "SI"){
              this.$store
              .dispatch(
                "generatePreliquidationMassive", this.$refs.preAproveList.selectedValue
              )
              .then(res => {
                if (res) {
                  this.$root.$emit(
                    "showSnackBar",
                    "Se enviará a su correo el reporte",
                    "success"
                  );
                }
              });
            }
            else{
            this.$store
              .dispatch(
                "getCommissionsExcel",
                this.$refs.preAproveList.selectedValue
              )
              .then(res => {
                if (this.commissionsVisualizeExcel.byteLength < 100) {
                  this.$root.$emit(
                    "showSnackBar",
                    "No existen datos",
                    "warning"
                  );
                  return;
                }
                downloadEXCEL(this.commissionsExcel, "PRELIQUIDACION_".concat(this.$refs.preAproveList.selectedValue).concat(".xlsx"));
              });
            }
          } else {
            this.$root.$emit(
              "showSnackBar",
              "Debe seleccionar al menos una preliquidación",
              "warning"
            );
          }

          break;
        case 3:
          if (this.$refs.liqQuery.selectedValue != null) {
            if (this.$refs.liqQuery.commissionsLiquidation.find(({ number }) => number ===  this.$refs.liqQuery.selectedValue)["massive"] === "SI"){
              this.$store
              .dispatch(
                "generateLiquidationMassive", this.$refs.liqQuery.selectedValue
              )
              .then(res => {
                if (res) {
                  this.$root.$emit(
                    "showSnackBar",
                    "Se enviará a su correo el reporte",
                    "success"
                  );
                }
              });
            }
            else{
            this.$store
              .dispatch(
                "getCommissionsExcel",
                this.$refs.liqQuery.selectedValue
              )
              .then(res => {
                if (this.commissionsVisualizeExcel.byteLength < 100) {
                  this.$root.$emit(
                    "showSnackBar",
                    "No existen datos",
                    "warning"
                  );
                  return;
                }
                downloadEXCEL(this.commissionsExcel, "LIQUIDACION_".concat(this.$refs.liqQuery.selectedValue).concat(".xlsx"));
              });
            }
          } else {
            this.$root.$emit(
              "showSnackBar",
              "Debe seleccionar al menos una preliquidación",
              "warning"
            );
          }
          break;
          case 5: // Este es el ID para Consulta de Preliquidaciones (Cifraseg)
            this.$root.$emit("showLoading", "Generando Excel...");
    
            this.$store.dispatch("getPreliquidationsExcel", this.$refs.preliquidationsQuery.filters)
            .then(() => {
            this.$root.$emit("hideLoading");

            if (this.preliquidationsExcel.byteLength < 100) {
            this.$root.$emit("showSnackBar", "No existen datos", "warning");
            return;
            }
              downloadEXCEL(
              this.preliquidationsExcel,
              "Consulta_Preliquidaciones.xlsx"
              );
            })
          .catch(err => {
          this.$root.$emit("hideLoading");
          this.$root.$emit("showSnackBar", "Error al generar el reporte", "error");
           });
          break;
          case 6:
          this.$store.dispatch("getSquareCommissionsExcel",this.$refs.squareComission.filters)
          .then(res => {
            if (this.squareCommissionsExcel.byteLength < 100) {
              this.$root.$emit("showSnackBar", "No existen datos", "warning");
              return;
            }
            downloadEXCEL(
              this.squareCommissionsExcel,
              "CuadreComisiones.xlsx"
            );
          });
          break;
        default:
          this.$root.$emit("showSnackBar", "No implementado", "warning");
          break;
      }
    }
  },
  data() {
    return {
      botonAprobarAproveBill:false,
      botonAprobarAprove:false,
      botonGenerar:false,
      items: [
        {
          id: 1,
          title: i18n.t("message.preliquidation")
        },
        {
          id: 2,
          title: i18n.t("message.preliquidationApproval")
        },
        {
          id: 3,
          title: i18n.t("message.liquidationQuery")
        },
        {
          id: 4,
          title: i18n.t("message.liquidationComission")
        },
        // {
        //   id: 6,
        //   title: i18n.t("message.squareComission")
        // }
      ],
      commissionType: undefined,
      showManualModal: false,
      showButtonGenerate: false
    };
  }
};
</script>